import { render } from "./PromptModal.vue?vue&type=template&id=5a9d1b04"
import script from "./PromptModal.vue?vue&type=script&lang=js"
export * from "./PromptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__